import { Action, createReducer, on } from '@ngrx/store';
import { InventoryComponent } from '../../inventory/inventory.component';
import * as CountsActions from '../actions/counts.actions';

export const countsFeatureKey = 'counts';

export interface State {
  inventory: any[],
  finalizedInventory: any,
  currentInventory: any,
  currentInventoryItem: any;
  isLoading: boolean,
  currentId,
  currentType: string,
  mostRecent: any[],
  totalCounted: number
  sortType: any
  currentPage: number,
  total: number,
}

export const initialState: State = {
  inventory: null,
  currentInventoryItem: null,
  finalizedInventory: null,
  isLoading: true,
  currentId: null,
  currentType: 'count',
  currentInventory: {},
  mostRecent: null,
  totalCounted: 0,
  sortType: {
    sortActive: 'prdNameEn',
    sortDirection: 'ASC'
  },
  currentPage: 0,
  total: 0
};

export const reducer = createReducer(
  initialState,


  /**
   * Inventory List
   */
  on(CountsActions.loadCounts, state => state),
  on(CountsActions.loadCountsSuccess, (state, { inventory , total}) => ({
    ...state,
    inventory: inventory,
    total: total,
    isLoading: false
  })),
  on(CountsActions.loadInventoryItemSuccess, (state, { data }) => ({
    ...state,
    currentInventoryItem: data
  })),
  on(CountsActions.loadFinalizedCountsSuccess, (state,  data ) => ({
    ...state,
    finalizedInventory: data,
  })),
  on(CountsActions.loadCountsFailure, (state, action) => ({ ...state, isLoading: false })),
  on(CountsActions.deleteCount, (state, action) => ({
    ...state,
  })),

  /**
   * Search Inventory
   */
  on(CountsActions.searchFinalizedCounts, (state, action) => ({
    ...state,
    query: action.query,
    isLoading: true
  })),
  on(CountsActions.searchFinalizedCountsSuccess, (state, data ) => ({
    ...state,
    finalizedInventory: data,
    isLoading: false
  })),
  on(CountsActions.searchFinalizedCountsFailure, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  })),

  //search box
  on(CountsActions.searchDraftCounts, (state, action) => ({
    ...state,
    query: action.query,
    isLoading: true
  })),
  on(CountsActions.searchDraftCountsSuccess, (state,  data ) => ({
    ...state,
    inventory: data.inventory,
    total: data.total,
    isLoading: false
  })),
  on(CountsActions.searchDraftCountsFailure, (state, action) => ({
    ...state,
    inventory: [],
    total: 0,
    error: action.error,
    isLoading: false,
  })),

  //filter type
  on(CountsActions.setFilterType, (state, action) => ({
    ...state,
    filterType: action.filterType,
    filterID: action.filterID,
    currentPage: 0
  })),

  //pager
  on(CountsActions.incrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage + 1
  })),
  on(CountsActions.decrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage - 1
  })),
  on(CountsActions.incrementPage, (state, action) => ({ 
    ...state,
  })),
  on(CountsActions.incrementPageSuccess, (state, action) => ({ 
    ...state,
    currentPage: action.currentPage
  })),

  /**
   * Single Inventory Count
   */
  on(CountsActions.loadCount, state => ({
    ...state,
    isLoading: true
  })),
  on(CountsActions.loadCountSuccess, (state, action) => ({
    ...state,
    currentInventory: action.data,
    isLoading: false
  })),
  on(CountsActions.loadCountFailure, (state, action) => ({ ...state, isLoading: false })),

  on(CountsActions.resetCurrentInventory, state => ({
    ...state,
    currentInventory: null
  })),
  on(CountsActions.loadFinancial, state => ({
    ...state,
    isLoading: true
  })),
  on(CountsActions.loadFinancialSuccess, (state, action) => ({
    ...state,
    currentInventory: action.data,
    isLoading: false
  })),
  on(CountsActions.loadFinancialFailure, (state, action) => ({ ...state, isLoading: false })),

  /**
   * Reorder
   */
  on(CountsActions.loadReorder, state => ({
    ...state,
    isLoading: true
  })),
  on(CountsActions.loadReorderSuccess, (state, action) => ({
    ...state,
    currentInventory: action.data,
    isLoading: false
  })),
  on(CountsActions.loadReorderFailure, (state, action) => ({ ...state, isLoading: false })),

  /**
   * PO
   */
  on(CountsActions.loadPO, state => ({
    ...state,
    isLoading: true
  })),
  on(CountsActions.loadPOSuccess, (state, action) => ({
    ...state,
    currentInventory: action.data,
    isLoading: false
  })),
  on(CountsActions.loadPOFailure, (state, action) => ({ ...state, isLoading: false })),

  /**
   * PS
   */
  on(CountsActions.loadPS, state => ({
    ...state,
    isLoading: true
  })),
  on(CountsActions.loadPSSuccess, (state, action) => ({
    ...state,
    currentInventory: action.data,
    isLoading: false
  })),
  on(CountsActions.loadPSFailure, (state, action) => ({ ...state, isLoading: false })),

  /**
   * Print Count
   */
  on(CountsActions.loadPrintCount, state => ({
    ...state,
    isLoading: true
  })),
  on(CountsActions.loadPrintCountSuccess, (state, action) => ({
    ...state,
    currentInventory: action.data,
    isLoading: false
  })),
  on(CountsActions.loadPrintCountFailure, (state, action) => ({ ...state, isLoading: false })),

  /**
   * Load Excel
   */
     on(CountsActions.loadExcel, state => ({
      ...state,
      isLoading: true
    })),
    on(CountsActions.loadExcelSuccess, (state, action) => ({
      ...state,
      currentInventory: action.data,
      isLoading: false
    })),
    on(CountsActions.loadExcelFailure, (state, action) => ({ ...state, isLoading: false })),
  on(CountsActions.deleteCount, (state, action) => ({
    ...state,
    action
  })),
  on(CountsActions.deleteCountSuccess, (state, action) => ({
    ...state,
    inventory: state.inventory.filter(item => item.invID != action.invID)
  })),
  on(CountsActions.setCurrentID, (state, action) => ({
    ...state,
    currentId: action.currentId,
    isLoading: true
  })),
  on(CountsActions.setCurrentIDSuccess, (state, action) => ({
    ...state,
    currentId: action.currentId
  })),
  on(CountsActions.setCurrentType, (state, action) => ({
    ...state,
    currentType: action.currentType
  })),
  on(CountsActions.loadMostRecentSuccess, (state, action) => ({
    ...state,
    mostRecent: action.data
  })),
  on(CountsActions.loadMostRecentBasicSuccess, (state, action) => ({
    ...state,
    mostRecent: action.data
  })),
  on(CountsActions.removeMostRecentSuccess, (state, action) => ({
    ...state,
    mostRecent: state.mostRecent.filter(item => item.invID != action.invID)
  })),
  on(CountsActions.setSortType, (state, action) => ({
    ...state,
    sortType: action.sortType
  })),
  on(CountsActions.finalizeCountsSuccess, (state, { data }) => ({
    ...state,
    inventory: state.inventory.filter(item => {
      if(!data.data.inventory.includes(item.invID)){
        return item;
      }
    })
  })),
  on(CountsActions.draftCountsSuccess, (state, { data }) => ({
    ...state,
    finalizedInventory: {
      ...state.finalizedInventory,
      inventory: state.finalizedInventory.inventory.filter(item => {
        return !data.inventory.includes(item.invID);
      })
    }
  })),
  on(CountsActions.deleteProduct, (state, action) => ({
    ...state,
  })),
  on(CountsActions.deleteProductSuccess, (state, action) => ({
    ...state,
    currentInventory: {
      ...state.currentInventory,
      invItems: state.currentInventory.invItems.filter(invItems => invItems.prdID != action.prdID)
    }
  }))
);
